import { Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const HeaderComponent = () => {
  const location = useLocation();
  
  const [headerText, setHeaderText] = useState("")

// useEffect hook to run the function when the location changes
  useEffect(() => {
  const updateHeaderText = () => {
    const pathname = location.pathname;

    switch (pathname) {
      case "/":
        setHeaderText("");
        break; 
      case "/Barriers":
        setHeaderText("Barriers");
        break; 
      case "/Joys":
        setHeaderText("Joys");
        break; 
      case "/Fear":
        setHeaderText("Fear");
        break; 
      case "/Joys2":
        setHeaderText("Joys II");
        break; 
      case "/Lost&Found":
        setHeaderText("Lost and Found");
        break; 
      case "/Milestones":
        setHeaderText("Milestones");
        break; 
      case "/About":
        setHeaderText("About");
        break; 
      default:
        setHeaderText("");
        break; 
    }
  };

    updateHeaderText();
  }, [location]);

  return (
    <div className="header">
        <Text>
      {headerText}
      </Text>
    </div>
  );
};

export default HeaderComponent;